<template>
  <div id="components">
    <a-table
      :rowSelection="rowSelection"
      :dataSource="data"
      :pagination="false"
    >
      <a-table-column title="商品" dataIndex="name" key="name" width="16%" />
      <a-table-column
        title="详细信息"
        dataIndex="detail"
        key="detail"
        width="23%"
      />
      <a-table-column title="购买时长 / 档期" key="time">
        <template slot-scope="text, record">
          <span>
            <a-range-picker
              v-model="record.dates"
              @openChange="state => openChange(state, record)"
              :disabledDate="disabledDate"
              :disabledTime="disabledRangeTime"
              :placeholder="['起始日', '截止日']"
              :ranges="{
                半年期: [
                  moment().startOf(''),
                  moment().subtract(-0.5, 'years')
                ],
                一年期: [moment().startOf(''), moment().subtract(-1, 'years')],
                一年半期: [
                  moment().startOf(''),
                  moment().subtract(-1.5, 'years')
                ],
                两年期: [moment().startOf(''), moment().subtract(-2, 'years')],
                两年半期: [
                  moment().startOf(''),
                  moment().subtract(-2.5, 'years')
                ],
                三年期: [moment().startOf(''), moment().subtract(-3, 'years')]
              }"
            >
              <template slot="renderExtraFooter">
                <div class="timefoot">
                  <a-icon type="sound" />
                  购买一年，立享9.5折，两年以上享8.8折优惠
                </div>
              </template>
            </a-range-picker>
          </span>
        </template>
      </a-table-column>

      <a-table-column title="购买数量" key="num" dataIndex="num" width="10%">
        <template slot-scope="text, record">
          <a-input-number
            :min="1"
            :max="10000"
            :precision="0"
            v-model="record.num"
          />
        </template>
      </a-table-column>

      <a-table-column
        title="单价 / 日"
        dataIndex="price"
        key="price"
        align="center"
      />

      <a-table-column
        title="操作"
        key="action"
        width="6%"
        align="center"
        scopedSlots="{ customRender: 'action' }"
      >
        <template slot-scope="text, record, index">
          <div>
            <span>
              <a-popconfirm
                title="确认删除?"
                okText="确认"
                cancelText="取消"
                v-if="data.length"
                @confirm="() => onDelete(record)"
              >
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
      </a-table-column>
    </a-table>

    <div class="foot">
      <div class="leftfoot">
        已选 (<span>{{ total }}</span
        >)
      </div>

      <div class="leftfoot" @click="warningtime">批量删除</div>

      <a-button-group>
        <a-button
          type="primary"
          icon="shopping-cart"
          :size="size"
          class="largefont"
          >立即结算</a-button
        >
      </a-button-group>

      <div class="rightfoot">
        总计 ：<span class="price">{{ price | RMB }}</span>
      </div>
      <div class="sale">
        已优惠 ：<span class="discount">{{ discount | RMB }}</span>
      </div>
    </div>
  </div>
</template>

<style>
#components {
  width: 1200px;
  margin: 0 auto;
  font-size: 25px;
  font-weight: normal;
}
.foot {
  border: 1px solid #1890ff;
  border-bottom: 0px;
  position: fixed;
  bottom: 0;
  width: 1200px;
  height: 60px;
}
.timefoot {
  color: #ff1190;
}
.ant-btn-group {
  float: right;
}
.ant-btn-group > .ant-btn:only-child {
  border-radius: 0px;
  height: 60px;
  line-height: 60px;
}
.largefont {
  font-size: 18px;
}
.price {
  font-size: 23px;
  color: #ff9100;
  font-weight: 300;
  letter-spacing: 1px;
}
.discount {
  color: #35b35a;
  font-weight: 300;
  letter-spacing: 1px;
}
.leftfoot {
  float: left;
  margin: 20px;
  font-size: 16px;
}
.rightfoot {
  float: right;
  font-weight: bold;
  margin: 14px;
  font-size: 16px;
}
.sale {
  float: right;
  margin: 23px 1px;
  font-size: 15px;
}
</style>

<script>
import moment from "moment";

const data = [
  {
    key: "1",
    name: "Mac Pro",
    price: 100,
    dates: [],
    num: 1,
    detail: "New York No. 1 Lake New York"
  },
  {
    key: "2",
    name: "iPhone SX",
    price: 666,
    dates: [],
    num: 2,
    detail: "Sidney No. 16 Park New York"
  },
  {
    key: "3",
    name: "iPad Pro",
    price: 888,
    dates: [],
    num: 3,
    detail: "New York No. 18886 Lake New Washington",
    agioA: 0.95, //一级折扣
    agioB: 0.88,
    agioC: 0.88
  }
];

function getRange(times) {
  if (times.length <= 0) {
    return 0;
  }
  let [start, end] = times;
  return end.diff(start, "day");
}

function getAgio(time) {
  if (time < 90) {
    return 0;
  } else if (time > 360) {
    return 0.95;
  } else if (time > 720) {
    return 0.88;
  } else {
    return 1;
  }
}

export default {
  data() {
    return {
      size: "large",
      selectedRows: [],
      data
    };
  },

  filters: {
    RMB(value) {
      if (!value) return "0.00";
      return "￥" + value.toLocaleString();
    }
  },

  computed: {
    total() {
      return this.selectedRows.length;
    },
    price() {
      return this.selectedRows.reduce((pre, curr) => {
        let time = getRange(curr.dates);
        let agio = getAgio(time);
        return pre + time * curr.price * agio * (curr.num | 0);
      }, 0);
    },
    discount() {
      return this.selectedRows.reduce((pre, curr) => {
        let time = getRange(curr.dates);
        let agio = getAgio(time);
        return pre + time * curr.price * (1 - agio) * (curr.num | 0);
      }, 0);
    },
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows;
        }
      };
    }
  },

  methods: {
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    warningtime() {
      this.$message.warning("请至少选择三个月以上档期时长", 5);
    },
    warningclash() {
      this.$message.warning("档期与现有档期冲突", 5);
    },
    openChange(state, record) {
      this.$nextTick(() => {
        if (state) {
          // false = close type
          record.open = true;
        } else {
          let dates = record.dates;
          if (dates.length === 2) {
            let diffTime = dates[1].diff(dates[0], "day");
            if (diffTime < 90) {
              this.warningtime();
              record.dates = [];
            } else {
              record.open = false;
            }
          }
        }
      });
    },
    onDelete(record) {
      let indexDatas = this.data.indexOf(record);
      let indexSelectRow = this.selectedRows.indexOf(record);
      this.data.splice(indexDatas, 1);
      this.selectedRows.splice(indexDatas, 1);
    },
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },

    disabledRangeTime(_, type) {
      if (type === "start") {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56]
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56]
      };
    },
    delete(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    handleSizeChange(e) {
      this.size = e.target.value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cart/Cart.vue